import React from "react";
import { joinClasses, metricToneClasses } from "./shared.js";

export function MetricCard({
  className = "",
  compactNote = false,
  children = null,
  interactive = false,
  label,
  labelClassName = "",
  note = "",
  noteInline = false,
  noteClassName = "",
  noteProps = {},
  showLabel = true,
  tone = "neutral",
  value,
  valueClassName = "",
  valueProps = {},
  ...props
}) {
  const Component = interactive ? "button" : "div";
  const componentProps = {
    ...props,
  };

  if (interactive && !componentProps.type) {
    componentProps.type = "button";
  }

  return (
    <Component
      data-metric-card="true"
      className={joinClasses([
        "grid min-w-0 gap-1 rounded-[16px] border px-3 py-2 text-left",
        metricToneClasses[tone] || metricToneClasses.neutral,
        interactive
          ? "appearance-none transition duration-150 hover:-translate-y-px hover:border-[rgba(15,92,87,0.24)] hover:shadow-[0_16px_30px_rgba(57,43,24,0.08)] focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2"
          : "",
        className,
      ])}
      {...componentProps}
    >
      {showLabel ? (
        <span
          className={joinClasses([
            "text-[0.67rem] font-black uppercase tracking-[0.07em]",
            tone === "danger" || tone === "warning" ? "text-current" : "text-muted-strong",
            labelClassName,
          ])}
        >
          {label}
        </span>
      ) : null}
      {noteInline ? (
        <div className="flex flex-wrap items-baseline gap-x-2 gap-y-1">
          <strong
            className={joinClasses([
              "text-[0.98rem] font-black leading-[1.12] tracking-[-0.01em]",
              valueClassName,
            ])}
            {...valueProps}
          >
            {value}
          </strong>
          {note ? (
            <span
              className={joinClasses([
                "text-[0.64rem] leading-[1.18]",
                tone === "danger" || tone === "warning" ? "text-current/80" : "text-muted",
                compactNote ? "whitespace-nowrap" : "",
                noteClassName,
              ])}
              {...noteProps}
            >
              {note}
            </span>
          ) : null}
        </div>
      ) : (
        <>
          <strong
            className={joinClasses([
              "text-[0.98rem] font-black leading-[1.12] tracking-[-0.01em]",
              valueClassName,
            ])}
            {...valueProps}
          >
            {value}
          </strong>
          {note ? (
            <p
              className={joinClasses([
                "text-[0.64rem] leading-[1.18]",
                tone === "danger" || tone === "warning" ? "text-current/80" : "text-muted",
                compactNote ? "whitespace-nowrap" : "",
                noteClassName,
              ])}
              {...noteProps}
            >
              {note}
            </p>
          ) : null}
        </>
      )}
      {children}
    </Component>
  );
}
